import React, { Component } from "react";
import ViewOemReport from "../../../LocomotiveOEMRecord/viewOEMReport/ViewOemReport";
import { CRUDFunction } from "../../../../reduxCURD/container";
import moment from "moment";
import { curdActions } from "../../../../reduxCURD/actions";
import InputTypeDropdown from "../../../SingleInputs/InputTypeDropdown";

class ViewReportOfOEM extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allReports: [],
      filteredReports: [],
      OverHaul: null,
      selectedRange: "",
      Ranges: [],
    };
    this.readyArguments = this.readyArguments.bind(this);
    this.getReportsDataFromServer = this.getReportsDataFromServer.bind(this);
    this.getOverhaulInfoFromServer = this.getOverhaulInfoFromServer.bind(this);
    this.CalculateOverHaulPeriod = this.CalculateOverHaulPeriod.bind(this);
  }

  componentDidMount() {
    if (this.props.selectedAsset) {
      this.readyArguments();
      this.getOverhaulInfoFromServer();
    }
  }

  CalculateOverHaulPeriod(overhaul) {
    const { selectedAsset } = this.props;
    if (overhaul && overhaul.opt2) {
      const transformed = overhaul.opt2.overhauls.reduce((list, e) => [...list, e.date], []);
      const Ranges = getRanges(selectedAsset.createdAt, transformed);
      //   const Ranges = getRanges("2020-01-01", transformed);
      const RangesState = Ranges.reduce(
        (prev, e, i) => [...prev, { value: `history ${i + 1}`, label: `OEM Record ${i + 1}`, data: e }],
        [],
      );
      this.setState({
        Ranges: RangesState,
        selectedRange: RangesState[RangesState.length - 1].value,
      });
    } else {
      this.setState({ Ranges: [] });
    }
  }
  componentDidUpdate(prevProps) {
    const { OEMData } = this.props;
    if (this.props.OEMOverHauls != prevProps.OEMOverHauls && this.props.actionType === "OEMOVERHAULS_READ_SUCCESS") {
      this.setState({ OEMOverHauls: this.props.OEMOverHauls[0] });
      this.CalculateOverHaulPeriod(this.props.OEMOverHauls[0]);
      //   this.CalculateOverHaulPeriod(mockOverHauls);
    }
    if (this.props.testSchedules != prevProps.testSchedules && this.props.testScheduleActionType === "TESTSCHEDULES_READ_SUCCESS") {
      this.setState({ allReports: this.props.testSchedules });
    }
    if (OEMData && this.props.OEMData != prevProps.OEMData) {
      this.readyArguments();
    }
  }

  getReportsDataFromServer(args) {
    this.props.getTestSchedules(`/getReportFilter${args}`);
  }

  getOverhaulInfoFromServer() {
    // Future use case for fetching overhaul information
    const { selectedAsset, OEMData } = this.props;
    if (selectedAsset && OEMData) this.props.getOEMOverHauls(`overhaulDetails/overhaulDetails_${selectedAsset._id}_${OEMData._id}`);
  }

  readyArguments() {
    const { selectedAsset, OEMData } = this.props;
    if (selectedAsset && OEMData) {
      const additionalQuery = `&assetId=${selectedAsset._id}&status=exec&testCode=${OEMData.code}`;

      const dateRange = {
        from: new Date(moment(selectedAsset.createdAt).startOf("day")),
        // from: new Date(moment("2020-01-01").startOf("day")),
        today: new Date(moment().startOf("day")),
        to: new Date(moment().endOf("day")),
      };

      const pInspecSchedule = "Scheduled";
      const queryParams = { ...dateRange, inspecSchedule: pInspecSchedule };

      const jsonArray = encodeURIComponent(JSON.stringify(queryParams));
      const args = `?dateRange=${jsonArray}${additionalQuery ? additionalQuery : ""}`;
      console.log(args);
      this.getReportsDataFromServer(args);
    }
  }
  getReportData = (selectedRange, Ranges, allReports) => {
    if (Ranges.length > 0 && allReports.length > 0) {
      const range = Ranges.find((e) => selectedRange === e.value);

      if (range && range.data) {
        const { from, to } = range.data;

        const filteredReports = allReports.filter((report) => {
          const reportDate = moment(report.date);
          return reportDate.isBetween(from, to, null, "[]");
        });

        return filteredReports;
      }
    }
    return allReports;
  };
  render() {
    const { isOpen, onClose, OEMData, selectedAsset, titleStyle } = this.props;
    const { allReports, selectedRange, Ranges } = this.state;

    const filteredReports = this.getReportData(selectedRange, Ranges, allReports);
    return (
      OEMData && (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
              paddingBlock: "5px",
            }}
          >
            {Ranges.length > 0 && (
              <InputTypeDropdown
                value={selectedRange}
                label="Select OEM:"
                onChange={(v) => {
                  this.setState({ selectedRange: v });
                }}
                options={Ranges}
                containerStyles={{
                  paddingInline: "10px",
                  paddingBlock: "5px",
                }}
              />
            )}
          </div>
          <ViewOemReport
            asset={selectedAsset}
            data={filteredReports || []}
            OEMData={OEMData.opt2}
            configuredOEMName={OEMData.opt2.title || OEMData.code}
          />
        </div>
      )
    );
  }
}

const getTestSchedules = curdActions.getTestSchedules;

const actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
  others: { getTestSchedules },
};

const variables = {
  testScheduleReducer: {
    testSchedules: [],
  },
};

const ViewReportOfOEMContainer = CRUDFunction(
  ViewReportOfOEM,
  "OEMOverHauls",
  actionOptions,
  variables,
  ["testScheduleReducer"],
  "applicationlookups",
);

export default ViewReportOfOEMContainer;

// const mockOverHauls = {
//   opt2: {
//     overhauls: [
//       { engineHours: 4000, date: "2022-12-30" },
//       { engineHours: 6000, date: "2023-12-30" },
//     ],
//   },
// };

const getRanges = (assetCreation, rangeDates) => {
  let range = [];
  for (let i = 0; i <= rangeDates.length; i++) {
    if (i === 0) {
      range.push({ from: new Date(moment(assetCreation).startOf("day")), to: new Date(moment(rangeDates[i]).endOf("day")) });
    } else if (i === rangeDates.length) {
      range.push({ from: new Date(moment(rangeDates[i - 1]).endOf("day")), to: new Date(moment().endOf("day")) });
    } else {
      range.push({ from: new Date(moment(rangeDates[i - 1]).endOf("day")), to: new Date(moment(rangeDates[i]).endOf("day")) });
    }
  }
  return range;
};



// WEBPACK FOOTER //
// ./src/components/AssetView/OEM/ViewReport/ViewReport.jsx